const favesProductSlider = new Swiper('.favorite-products-slider', {
  slidesPerView: 1.5,
  loop: true,
  spaceBetween: 20,
  centerInsufficientSlides: true,
  watchOverflow: true,
  centeredSlides: true,
  navigation: {
    prevEl: '.about-favorites .swiper-button-prev',
    nextEl: '.about-favorites .swiper-button-next'
  },
  breakpoints: {
    651: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    851: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    951: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 30,
    },
    1051: {
      slidesPerView: 5,
      centeredSlides: false,
      spaceBetween: 30,
    }
  }
});